module.exports = __webpack_public_path__ + "static/media/service-img2.d32ee505.png";